import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/(agent)/agent')({
    component: AgentPathLayout,
});

function AgentPathLayout() {
    return <Outlet />;
}
